<template>
  <card :title="$t('consumer-profile.title')">
    <template #action-bar>
      <el-button
        v-if="!isEditFormShown"
        type="ghost"
        icon="i-pencil-o--16"
        @click="showEditForm"
      >
        {{ $t('action.edit') }}
      </el-button>
    </template>
    <template v-if="isEditFormShown">
      <consumer-profile-edit-form
        :value="consumerProfile"
        @submit="hideEditForm"
        @cancel="hideEditForm"
      />
    </template>
    <template v-else>
      <consumer-profile-property-list :value="consumerProfile" />
    </template>
  </card>
</template>

<script>
import { mapGetters } from 'vuex';
import Card from '@/app/components/Card';
import ConsumerProfilePropertyList from '@/app/components/consumer-profile/ConsumerProfilePropertyList';
import ConsumerProfileEditForm from '@/app/components/consumer-profile/ConsumerProfileEditForm';

export default {
  name: 'ConsumerProfileCard',
  components: {
    Card,
    ConsumerProfilePropertyList,
    ConsumerProfileEditForm
  },
  data() {
    return {
      isEditFormShown: false
    };
  },
  computed: {
    ...mapGetters('app', [
      'consumerProfile'
    ])
  },
  methods: {
    showEditForm() {
      this.isEditFormShown = true;
    },
    hideEditForm() {
      this.isEditFormShown = false;
    }
  }
};
</script>
